<div *ngIf="rowsForm" [formGroup]="rowsForm">
  @if (isEditable) {
    <div class="repeatable-toolbar">
      <div class="left">
        <span class="title">{{ field.label }}</span>
        <span class="muted"> {{ currentCount }} de {{ maxRows }} </span>
      </div>

      <div class="center">
        <span class="muted">Rellene los campos necesarios</span>
      </div>

      <div class="right">
        <button
          pButton
          type="button"
          class="p-button-success"
          label="{{ field.input.repeatableGroupConfiguration?.addButtonLabel }}"
          (click)="addRow()"
          [disabled]="!canAddRow()"
        ></button>
      </div>
    </div>
  }

  <div
    class="repeatable-group"
    formArrayName="rows"
    [style.--rg-cols]="visibleSubFields().length"
  >
    <div class="repeatable-header">
      <div class="repeatable-header-cell"></div>

      <ng-container *ngFor="let sf of visibleSubFields(); trackBy: trackByIndex">
        <div class="repeatable-header-cell">
          <label class="field-label">{{ sf.label }}</label>
        </div>
      </ng-container>

    </div>

    <div
      class="repeatable-row"
      *ngFor="let _row of rowsArray.controls; let rowIndex = index; trackBy: trackByIndex"
      [formGroupName]="rowIndex"
    >
      <div class="repeatable-index">{{ rowIndex + 1 }}</div>

      <ng-container *ngFor="let sf of visibleSubFields(); trackBy: trackByIndex">
        <div class="repeatable-cell">

          @switch (sf.input.type) {
            @case (INPUT.ONLY_TEXT) {
              <p class="read-only">{{ rowsArray.at(rowIndex).get(sf.key)?.value || '0,00' }}</p>
            }

            @case (INPUT.NUMERIC) {
              <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="number"
                [formControlName]="sf.key"
                placeholder="..."
                [readonly]="!!sf.computeValue"
              />
            }

            @case (INPUT.TEXT) {
              <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="text"
                [formControlName]="sf.key"
                placeholder="..."
                [maxlength]="sf.input.maxLength ?? null"
                [readonly]="!!sf.computeValue"
              />
            }

            @case (INPUT.PASSWORD) {
              <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="password"
                [formControlName]="sf.key"
                placeholder="..."
                [readonly]="!!sf.computeValue"
              />
            }

            @case (INPUT.TEXTAREA) {
              <textarea
                pTextarea
                class="w-100"
                [rows]="sf.input.textAreaConfiguration?.rows ?? 3"
                [cols]="sf.input.textAreaConfiguration?.cols ?? 20"
                [readonly]="!isEditable || !!sf.computeValue"
                [formControlName]="sf.key"
                placeholder="..."
              ></textarea>
            }

            @case (INPUT.TEXT_MASK) {
              <p-inputMask
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [mask]="sf.input.textMaskConfiguration?.mask ?? ''"
                [placeholder]="sf.input.textMaskConfiguration?.mask ?? ''"
              ></p-inputMask>
            }

            @case (INPUT.DROPDOWN) {
              <p-select
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                optionLabel="label"
                optionValue="value"
                [options]="dropdownOptions(sf)"
                [disabled]="!isEditable || !!sf.computeValue"
              ></p-select>
            }

            @case (INPUT.DROPDOWN_SEARCH) {
              <p-select
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [virtualScroll]="true"
                [virtualScrollItemSize]="40"
                [options]="dropdownOptions(sf)"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [disabled]="!isEditable || !!sf.computeValue"
              ></p-select>
            }

            @case (INPUT.MULTISELECT) {
              <p-listbox
                *ngIf="isEditable; else readOnly"
                [options]="dropdownOptions(sf)"
                [metaKeySelection]="false"
                [checkbox]="true"
                [multiple]="true"
                [showToggleAll]="false"
                [listStyle]="{
                  'max-height': sf.input.dropdownConfiguration?.hasMaxHeight ? '100%' : '15rem',
                  'min-height': '18px'
                }"
                [formControlName]="sf.key"
                [disabled]="!isEditable || !!sf.computeValue"
              ></p-listbox>
            }

            @case (INPUT.MULTISELECT_SEARCH) {
              <p-multiselect
                *ngIf="isEditable; else readOnly"
                [options]="dropdownOptions(sf)"
                [formControlName]="sf.key"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [showToggleAll]="true"
                placeholder="Seleccionar"
                [maxSelectedLabels]="3"
                styleClass="w-full md:w-80"
                [disabled]="!isEditable || !!sf.computeValue"
              ></p-multiselect>
            }

            @case (INPUT.CALENDAR) {
              <p-datePicker
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [firstDayOfWeek]="1"
                [dateFormat]="sf.input.calendarConfiguration?.calendarDateFormat ?? 'dd/mm/yy'"
                [disabledDates]="sf.input.calendarConfiguration?.disabledDates ?? []"
                (onSelect)="sf.input.calendarConfiguration?.onSelect?.($event)"
                dataType="string"
                placeholder="..."
                appendTo="body"
                [view]="sf.input.calendarConfiguration?.calendarView ?? 'date'"
                [disabled]="!isEditable || !!sf.computeValue"
              ></p-datePicker>
            }

            @case (INPUT.TIME) {
              <p-datePicker
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [timeOnly]="true"
                placeholder="..."
                dateFormat="hh:mm"
                dataType="string"
                [disabled]="!isEditable || !!sf.computeValue"
              ></p-datePicker>
            }

            @case (INPUT.SWITCH) {
              @if (!isEditable) {
                <div style="pointer-events: none;">
                  <p-toggleswitch
                    [formControlName]="sf.key"
                    [trueValue]="'1'"
                    [falseValue]="'0'"
                  ></p-toggleswitch>
                </div>
              } @else {
                <p-toggleswitch
                  [formControlName]="sf.key"
                  [trueValue]="'1'"
                  [falseValue]="'0'"
                  [disabled]="!!sf.computeValue"
                ></p-toggleswitch>
              }
            }

            @default {
              <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="text"
                [formControlName]="sf.key"
                placeholder="..."
                [readonly]="!!sf.computeValue"
              />
            }
          }

          <ng-template #readOnly>
            <p class="read-only">{{ readOnlyCellText(sf, rowIndex) }}</p>
          </ng-template>
        </div>
      </ng-container>

      @if (isEditable) {
        <div class="repeatable-actions">
          <button
            pButton
            type="button"
            class="p-button-danger p-button-rounded"
            icon="pi pi-trash"
            (click)="deleteRow(rowIndex)"
            [disabled]="!canDeleteRow()"
          ></button>
        </div>
      }
    </div>
  </div>
</div>
